import React from "react";
import HeroSection from "../components/HeroSection/HeroSection";
//import HomeNavbar from "../components/Portfolio/Header";
import HomeNavbar from "../components/Navbars/HomeNavbar";
import HomeFooter from "../components/Footer/HomeFooter";
import "./Home.css";
import MoreInfo from "../components/HeroSection/MoreInfo";
import GapwithBG from "./GapwithBG";
import Pricing from "../components/HeroSection/Pricing";
import ScrollToTop from "./ScrollToTop";

function Home() {
  return (
    <div>
      <ScrollToTop></ScrollToTop>
      <HomeNavbar></HomeNavbar>
      <GapwithBG></GapwithBG>
      <HeroSection></HeroSection>
      <GapwithBG></GapwithBG>
      <Pricing></Pricing>
      <GapwithBG></GapwithBG>
      <MoreInfo></MoreInfo>

      <HomeFooter></HomeFooter>
    </div>
  );
}

export default Home;
